/**
 * Resolve in-app notification deep links.
 * Prefer explicit `link` from the API; fall back using metadata and role.
 */
export function notificationLink(notification, user = null) {
  const data = notification?.data || {};
  const type = String(notification?.type || '').toUpperCase();
  const role = String(user?.role || '').toUpperCase();

  if (type === 'OWNER_PLAN_UPGRADE') {
    if (role === 'ADMIN') {
      return '/admin?tab=ops';
    }
    if (role === 'OWNER') {
      return '/owner/plans';
    }
    return null;
  }

  if (notification?.link) {
    return notification.link;
  }

  if (data.inquiry_id && (type === 'BOOKING' || data.inquiry_id)) {
    if (data.audience === 'owner') {
      return '/owner/dashboard';
    }
    if (data.audience === 'guest') {
      return '/bookings';
    }
    if (role === 'OWNER' || role === 'ADMIN') {
      return '/owner/dashboard';
    }
    return '/bookings';
  }

  if (data.listing_id && type.startsWith('LISTING_')) {
    return `/owner/listings/${data.listing_id}/edit`;
  }

  if (data.listing_id) {
    return `/listings/${data.listing_id}`;
  }

  return null;
}
